import { WorkspaceFCOContainer } from '../../../core/types/fcoTypes';

import { Empty, Loading, ViewLayout } from '@lithos';
import { useGetFcos } from '../../../api/fcos';
import { useUserSettings } from '../../context/UserSettingsContext';
import EntitiesList from './EntitiesList';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';

export const EntitiesContainer = () => {
  const { workspace, workspaceDetails } = useUserSettings();

  const { data, isError, isLoading } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        entities: data.entities,
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: { label: workspace ?? '', url: `/repo/${workspace}` },
      items: [{ label: 'Entities', url: `/repo/${workspace}/entities` }],
    },
    title: 'Entities',
    subtitle: 'Entities are the primary keys for your features.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.ENTITIES,
  };

  if (isLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  if (isError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            title={<>Error Loading Entities</>}
            description={<>There was an error loading Entities for this workspace. Please try again.</>}
            placement="full-page"
            useCase="errorUnknown"
            actions={undefined}
          />
        }
      />
    );
  }
  return (
    <ViewLayout
      header={headerProps}
      content={
        <EntitiesList items={data.entities ?? []} idToFcoMap={data?.idToFcoMap} workspace={workspace as string} />
      }
    />
  );
};

export default EntitiesContainer;
